export const BASE_URL = '//api.bilibili.com';